import { render, staticRenderFns } from "./ResetView.vue?vue&type=template&id=077dfe08&scoped=true&"
import script from "./ResetView.vue?vue&type=script&lang=ts&"
export * from "./ResetView.vue?vue&type=script&lang=ts&"
import style0 from "./ResetView.vue?vue&type=style&index=0&id=077dfe08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077dfe08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
